import { render, staticRenderFns } from "./Life.vue?vue&type=template&id=853cc344&scoped=true&"
import script from "./Life.vue?vue&type=script&lang=ts&"
export * from "./Life.vue?vue&type=script&lang=ts&"
import style0 from "./Life.vue?vue&type=style&index=0&id=853cc344&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853cc344",
  null
  
)

export default component.exports